import { render } from "./BorderBottomColor.vue?vue&type=template&id=0a69f6fe&scoped=true&ts=true"
import script from "./BorderBottomColor.vue?vue&type=script&lang=ts"
export * from "./BorderBottomColor.vue?vue&type=script&lang=ts"

import "./BorderBottomColor.vue?vue&type=style&index=0&id=0a69f6fe&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a69f6fe"]])

export default __exports__